import React from 'react';
import styles from './SupplementStore.module.scss';
import { classNameGenerator, clsx } from '@/utils';
import { useAppSelector } from '@/hooks';
import { useRouter } from 'next/router';

const SupplementsStore = () => {
  const cls = classNameGenerator(styles)
  const { data } = useAppSelector((state) => state.healthProgramV1);
  const router = useRouter();

  if (!data?.supplementStore) {
    return <></>
  }

  const { products, categories } = data?.supplementStore || {}
  const onClick = (link) => {
    router.push(link)
  }
  return (
    <div className={cls("store-container")}>
      {/* Category Section */}
      <section className={clsx(cls("section"), cls("section-categories"))}>
        <div className={cls("section-header")}>
          <h2>Shop by Category</h2>
          <button onClick={() => onClick("https://shop.betheshyft.com/collections/all")} className={cls("view-all")}>View all &rarr;</button>
        </div>
        <div className={cls("category-grid")}>
          {categories.map((cat, i) => (
            <div
              onClick={() => onClick(cat?.link)}
              key={i} className={cls("category-card")}>
              <div className={cls("image-container")}>
                <img src={cat.image} alt={cat.title} />
              </div>
              <div className={cls("card-content")}>
                <h3>{cat.title}</h3>
                <p>{cat.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Bestselling Section */}
      <section className={clsx(cls("section"), cls("section-bestselling"))}>
        <div className={cls("section-header")}>
          <h2>Bestselling Supplements</h2>
          <button onClick={() => onClick("https://shop.betheshyft.com/collections/all")} className={clsx(cls("view-all"), cls("desktop-only"))}>View all &rarr;</button>
        </div>

        {/* The grid now handles horizontal scrolling via SCSS */}
        <div className={cls("product-grid")}>
          {products.map((prod, i) => (
            <div onClick={() => onClick(prod.link)} key={i} className={cls("product-card")}>
              <div className={cls("image-container")}>
                <img src={prod.image} alt={prod.name} />
              </div>
              <div className={cls("card-content")}>
                <div className={cls("card-content-inner")}>
                  <h4>{prod.name}</h4>
                  <span className={cls("weight")}>{prod.weight}</span>
                </div>
                <span className={cls("price")}>₹ {prod.price}</span>
              </div>
            </div>
          ))}
        </div>

        <button onClick={() => onClick("https://shop.betheshyft.com/collections/all")} className={clsx(cls("view-all-mobile"), cls("mobile-only"))}>View All</button>
      </section>
    </div>
  );
};

export default SupplementsStore;